import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class ToggleButton extends Vue {
	@Prop({ type: Boolean, required: true })
	public readonly value!: boolean;

	// Toggle action
	public toggle(event: Event): void {
    	const input = event.target as HTMLInputElement;
    	this.$emit("input", input.checked);
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/togglebutton/toggleButton.ts